export default __webpack_public_path__ + "static/media/CNo.40-2.2fe711f0.jpg";